import TemplateCardList, { TemplateCardListProps } from './TemplateCardList';

export type { TemplateCardListProps };
export default TemplateCardList;
